import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./hero-banner.module.scss";

type HeroBannerActionProps = Omit<BaseProps, "children"> & {
  /** One or several CTA links or buttons */
  children: ReactNode;
};

const rootClassName = "purpur-hero-banner";

const cx = c.bind(styles);

export const HeroBannerActions = ({ children, className, ...props }: HeroBannerActionProps) => {
  return (
    <div {...props} className={cx(`${rootClassName}__actions`, className)}>
      {children}
    </div>
  );
};
